import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FiInfo } from 'react-icons/fi';
import { NavLink, useParams } from 'react-router-dom';
import { IParams } from '../../../../../model/shared/IParams';
import { InternalRoutes } from '../../../../../enum/InternalRoutes';
import { Campaign } from '../../../../../model/campaign/Campaign';
import { CampaignDashboardService } from '../service';
import { ErrorToast } from '../../../../../utils/toasters';
import { IconMeasure } from '../../../../../shared/Icons';
import { priceSplitter } from '../../../../../utils/helpers/priceSplitter';
import CardLayout from '../../../../../shared/components/card/CardLayout';
import { MUTED_TEXT_COLOR } from '../../../../../utils/constants';
import TooltipOverlay from '../../../../../shared/components/tooltip/Tooltip';
import { DashStatsCardSkeleton } from './CampaignDashboardSkeletons';

export function CampaignMeasure() {
    const { t } = useTranslation();
    const { id } = useParams<keyof IParams>();

    const [measure, setMeasure] = useState<Campaign>();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        CampaignDashboardService.getMeasureData(+id!)
            .then(data => {
                setMeasure(data);
            })
            .catch(error => ErrorToast(error))
            .finally(() => setIsLoading(false));
    }, [id]);
    if (isLoading) {
        return <DashStatsCardSkeleton stats={2} withSubtitle className="" />;
    }
    return (
        <CardLayout>
            <NavLink className="d-flex cursor-pointer textHover" to={`${InternalRoutes.BRAND_CAMPAIGN_MEASURE}/${id}`}>
                <IconMeasure width="20" height="20" color={MUTED_TEXT_COLOR} classes={' mr-2'} />
                <div className="d-flex flex-column">
                    <h6 className=" d-flex mb-0 ">{t('brand.campaign.dashboard.measure.measure')}</h6>
                    <span className="text-muted">{t('brand.campaign.dashboard.booking.measureDesc')}</span>
                </div>
            </NavLink>
            <div className="d-flex my-3 flex-wrap justify-content-between align-items-center">
                <div>
                    <h3 className="mb-0 text-primary">{priceSplitter(measure?.totalReach ?? 0)}</h3>
                    <div className="d-flex align-items-center">
                        {t('brand.campaign.dashboard.measure.total_reach')}
                        <TooltipOverlay
                            className="ms-1"
                            content={t(`brand.campaign.dashboard.measure.total_reach_tooltip`)}
                        >
                            <FiInfo size={14} />
                        </TooltipOverlay>
                    </div>
                </div>
                <div>
                    <div className="d-flex align-items-end">
                        <div>
                            <h3 className="text-primary mr-2 mb-0">{measure?.reportedInfluencers ?? 0} </h3>
                        </div>
                        <div>
                            <h3 className="text-dark mb-0"> / {measure?.bookedInfluencers ?? 0}</h3>
                        </div>
                    </div>
                    <div>{t('brand.campaign.dashboard.measure.influencers_reported')}</div>
                </div>
                <div>
                    <div className="d-flex align-items-end">
                        <h3 className="text-primary mb-0 mr-2">{priceSplitter(measure?.engagementScore) ?? 0} </h3>
                        <div className="text-dark mb-1 "> %</div>
                    </div>
                    <div className="d-flex align-items-center">
                        {t('brand.campaign.dashboard.measure.engagement_score')}
                        <TooltipOverlay
                            className="ms-1"
                            content={t(`brand.campaign.dashboard.measure.engagement_scoreTooltip`)}
                        >
                            <FiInfo size={14} />
                        </TooltipOverlay>
                    </div>
                </div>
            </div>
        </CardLayout>
    );
}
